<template>
	<div class="elevator_box animate__animated animate__fadeIn">
		<div class="elevator">
			<div class="content_list">
				<div class="item_title">
					<div class="bar">设备编号：{{ currentElevator.number ? currentElevator.number : '' }}</div>
					<div class="bar">运行状态：{{ currentElevator.eqptStatus ? fnElevatorStatusToText(currentElevator.eqptStatus).msg : '' }}</div>
					<div class="operation">
                        <!-- <div class="search-btn orange" @click="showMark=true"><span>标定</span></div> -->
						<div class="search-btn orange" @click="fnRefresh"><span>刷新</span></div>
					</div>
				</div>
				<div class="item_box">
					<div class="box" v-show="statusIndex == 0"><Data :currentElevator="currentElevator" /></div>
					<div class="box" v-show="statusIndex == 1"><HoistingRecord :currentElevator="currentElevator" /></div>
					<div class="box" v-show="statusIndex == 2"><alarm :currentElevator="currentElevator" /></div>
					<div class="box" v-show="statusIndex == 3"><realTimeRecord :currentElevator="currentElevator" /></div>
				</div>
			</div>
			<div class="data_list">
				<div class="title">升降机({{ elevatorData.length }}台)</div>
				<div class="list_title">
					<div class="title_item">设备编号</div>
					<div class="title_item">安装位置</div>
					<div class="title_item">在线状态</div>
				</div>
				<div class="list_box">
					<div v-if="elevatorData">
						<div
							class="box_line"
							v-for="(item, index) in elevatorData"
							:key="item.id"
							@click="fnElevatorToggle(item, index)"
							:class="currentElevatorIndex == index ? 'active' : ''"
						>
							<div class="line_item">{{ item.number }}</div>
							<div class="line_item">{{ item.install_location }}</div>
							<div class="line_item">{{ fnOnlineStatusText(item.heartbeatTime).text }}</div>
						</div>
					</div>
				</div>
			</div>
		</div>
        <div class="dialog_mark" v-if="showMark">
          <el-dialog :custom-class="'animate__animated animate__fadeIn'" top="20vh" :modal="false" title="标定设置" :visible.sync="showMark" center>
            <div class="mark_content">
              <el-tabs v-model="activeName" @tab-click="handleClick">
                <el-tab-pane label="重量" name="first">
                  <div class="first_box">
                    <!-- <div class="box_line">
                      <div class="line_item">
                        <span class="title">实时重量</span>
                        <el-input v-model="weightInfo.now_weight"></el-input> t
                      </div>
                      <div class="line_item">
                        <span class="title">实时电压</span>
                        <el-input v-model="weightInfo.now_voltage"></el-input> v
                      </div>
                      <div class="line_item btn">
                         <div class="search-btn"><span>配 置</span></div>
                      </div>
                    </div> -->
                    <div class="box_line">
                      <div class="line_item">
                        <span class="title">实际重量1</span>
                        <el-input v-model="weightInfo.weight_one"></el-input> t
                      </div>
                      <div class="line_item">
                        <span class="title">电压值1</span>
                        <el-input v-model="weightInfo.voltage_one"></el-input> v
                      </div>
                      <div class="line_item btn">
                         <div class="search-btn"><span>记 录</span></div>
                      </div>
                    </div>
                    <div class="box_line">
                      <div class="line_item">
                        <span class="title">实际重量2</span>
                        <el-input v-model="weightInfo.weight_two"></el-input> t
                      </div>
                      <div class="line_item">
                        <span class="title">电压值2</span>
                        <el-input v-model="weightInfo.voltage_two"></el-input> v
                      </div>
                      <div class="line_item btn">
                        <div class="search-btn"><span>记 录</span></div>
                      </div>
                    </div>
                  </div>
                </el-tab-pane>
                <el-tab-pane label="高度" name="second">
                  <div class="second_box">
                    <div class="box_line">高度校准</div>
                    <!-- <div class="box_line">
                      <div class="line_item">
                        <span class="title">实时高度</span>
                        <el-input v-model="heightInfo.now_height"></el-input> t
                      </div>
                      <div class="line_item">
                        <span class="title">实时电压</span>
                        <el-input v-model="heightInfo.now_voltage"></el-input> v
                      </div>
                      <div class="line_item btn">
                         <div class="search-btn"><span>配 置</span></div>
                      </div>
                    </div> -->
                    <div class="box_line">
                      <div class="line_item">
                        <span class="title">实际高度1</span>
                        <el-input v-model="heightInfo.height_one"></el-input> t
                      </div>
                      <div class="line_item">
                        <span class="title">电压值1</span>
                        <el-input v-model="heightInfo.voltage_one"></el-input> v
                      </div>
                      <div class="line_item btn">
                         <div class="search-btn"><span>记 录</span></div>
                      </div>
                    </div>
                    <div class="box_line">
                      <div class="line_item">
                        <span class="title">实际高度2</span>
                        <el-input v-model="heightInfo.height_one"></el-input> t
                      </div>
                      <div class="line_item">
                        <span class="title">电压值2</span>
                        <el-input v-model="heightInfo.voltage_two"></el-input> v
                      </div>
                      <div class="line_item btn">
                         <div class="search-btn"><span>记 录</span></div>
                      </div>
                    </div>
                    <div class="box_line">楼层校准</div>
                    <!-- <div class="box_line">
                      <div class="line_item"></div>
                      <div class="line_item">
                        <span class="title">实时高度</span>
                        <el-input v-model="floorInfo.now_height"></el-input> v
                      </div>
                      <div class="line_item btn">
                         <div class="search-btn"><span>配 置</span></div>
                      </div>
                    </div> -->
                    <div class="box_line">
                      <div class="line_item">
                        <span class="title">楼层</span>
                        <el-input v-model="floorInfo.floor"></el-input> F
                      </div>
                      <div class="line_item">
                        <span class="title">高度</span>
                        <el-input v-model="floorInfo.height"></el-input> m
                      </div>
                      <div class="line_item btn">
                         <div class="search-btn"><span>记 录</span></div>
                      </div>
                    </div>
                  </div>
                </el-tab-pane>
                <el-tab-pane label="倾角" name="third">
                  <div class="third_box">
                    <!-- <div class="box_line">
                      <div class="line_item">
                        <span class="title">实时X轴</span>
                        <el-input v-model="dipInfo.now_x"></el-input>
                      </div>
                      <div class="line_item">
                        <span class="title">实时Y轴</span>
                        <el-input v-model="dipInfo.now_y"></el-input>
                      </div>
                      <div class="line_item btn">
                         <div class="search-btn"><span>配 置</span></div>
                      </div>
                    </div> -->
                    <div class="box_line">
                      <div class="line_item">
                        <span class="title">X轴实际角度1</span>
                        <el-input v-model="dipInfo.dip_x1"></el-input> deg
                      </div>
                      <div class="line_item">
                        <span class="title">Y轴实际角度1</span>
                        <el-input v-model="dipInfo.dip_y1"></el-input> deg
                      </div>
                      <div class="line_item btn">
                         <div class="search-btn"><span>记 录</span></div>
                      </div>
                    </div>
                    <div class="box_line">
                      <div class="line_item">
                        <span class="title">X轴实际角度2</span>
                        <el-input v-model="dipInfo.dip_x2"></el-input> deg
                      </div>
                      <div class="line_item">
                        <span class="title">Y轴实际角度2</span>
                        <el-input v-model="dipInfo.dip_y2"></el-input> deg
                      </div>
                      <div class="line_item btn">
                        <div class="search-btn"><span>记 录</span></div>
                      </div>
                    </div>
                  </div>
                </el-tab-pane>
              </el-tabs>
            </div>
          	<div slot="footer" class="dialog-footer">
              <div class="btn_line">
                  <div class="search-btn red" @click="showMark=false"><span>关 闭</span></div>
                  <div class="search-btn"><span>保 存</span></div>
              </div>
            </div>
          </el-dialog>
        </div>
	</div>
</template>

<script>
import Data from './components/Data';
import Alarm from './components/Alarm';
import HoistingRecord from './components/hoistingRecord';
import realTimeRecord from './components/realTimeRecord';
import request from '@/utils/request';
import APP from '@/utils/base';
import { getUserInfo, getEqptInfo, removeEqptInfo } from '@/utils/auth';
export default {
	components: {
		Data,
		Alarm,
		HoistingRecord,
		realTimeRecord
	},
	data() {
		return {
            activeName: 'first',
            showMark: false,
			timer: null,
			projectInfo: null, // 传递过来的项目信息
			projectName: '',
			statusIndex: 0,
			currentElevatorIndex: 0,
			elevatorData: [], // 塔机列表
			currentElevator: {
				number: '',
				eqptStatus: '',
				nowTime:''
			} ,// 当前设备信息
            isIndex: false,
            indexMsg: null,
            weightInfo:{
              // now_weight: '',// 实时重量
              // now_voltage: '',// 实时电压
              weight_one: '',// 实际重量1
              voltage_one: '',// 电压值1
              weight_two: '',// 实际重量2
              voltage_two: '',// 电压值2
            },
            heightInfo:{
              // now_height: '',//实时高度
              // now_voltage: '',// 实时电压
              height_one: '',// 实际高度1
              voltage_one: '',// 电压值1
              height_two: '',// 实际高度2
              voltage_two: '',// 电压值2
            },
            floorInfo:{
              // now_height: '',// 实时高度
              floor: '',// 楼层
              height: '',// 高度
            },
            dipInfo:{
              // now_x: '',// 实时X轴
              // now_y: '',// 实时Y轴
              dip_x1: '',// X轴实际角度1
              dip_y1: '',// Y轴实际角度1
              dip_x2: '',// X轴实际角度2
              dip_y2: '',// Y轴实际角度2
            }
		};
	},
	created() {
        let _msg = getEqptInfo()
        if(_msg&&_msg.pointType == '升降机设备'){
            this.isIndex = true
            this.indexMsg = _msg.pointNumber
        }
		this.projectID = getUserInfo().id;
		this.fnInit();
		this.timer = setInterval(() => {
			this.fnGetElevatorList();
		}, 100000);
	},
	beforeDestroy() {
        removeEqptInfo()
		clearInterval(this.timer);
	},
	methods: {
        handleClick(tab, event) { },
		// 查看塔机运行记录
		fnOpenElevatorRealTimeRecord() {
			this.statusIndex = 3;
		},
		// 查看塔机预报警次数
		fnOpenElevatorAlarm() {
			this.statusIndex = 2;
		},
		// 查看装载记录
		fnOpenHoistingRecord() {
			this.statusIndex = 1;
		},
		// 查看实时数据
		fnOpenHome() {
			this.statusIndex = 0;
		},
		// 记录切换
		fnStatusToggle(_el) {
			let _index = _el.target.dataset.index;
			if (_index != this.statusIndex) {
				this.statusIndex = _index;
			}
		},
		// 初始化
		fnInit() {
			this.fnGetElevatorList();
		},
		// 获取塔机列表
		fnGetElevatorList() {
			request({
				notLoading: true,
				url: 'elevator/get',
				method: 'GET',
				params: {
					project_id: this.projectID
				}
			})
				.then(res => {
					if (res.data.query.length > 0) {
						this.elevatorData = res.data.query;
                        if(this.isIndex){
                            for(let i in this.elevatorData){
                                if(this.elevatorData[i].number == this.indexMsg){
                                    this.currentElevatorIndex = i
                                    this.currentElevator.number = this.elevatorData[i].number;
                                    this.currentElevator.eqptStatus = this.elevatorData[i].eqptStatus;
                                    this.currentElevator.nowTime = ''+ new Date().getTime()
                                }
                            }
                        }else{
                            if (!this.currentElevator.number) {
                                this.currentElevator.number = res.data.query[0].number;
                                this.currentElevator.eqptStatus = res.data.query[0].eqptStatus;
                                this.currentElevator.nowTime = ''+ new Date().getTime()
                            }
                        }
					} else {
						this.currentElevator.number = '';
						this.currentElevator.eqptStatus = '';
					}
				})
				.catch(err => {
					this.$message.error(err.data);
				});
		},
		// 塔机运行状态
		fnElevatorStatusToText(_status) {
			if (_status) {
				return APP.fnCraneStatusToText(_status, 'elevator');
			}
		},
		// 获取选中塔机信息
		fnElevatorToggle(_item, _index) {
			this.currentElevatorIndex = _index;
			request({
				url: 'elevator/get',
				method: 'GET',
				params: {
					project_id: this.projectID,
					number: _item.number
				}
			})
				.then(res => {
					if (res.data.query.length > 0) {
						this.currentElevator.number = res.data.query[0].number;
						this.currentElevator.eqptStatus = res.data.query[0].eqptStatus;
						this.currentElevator.nowTime = ''+ new Date().getTime()
					}
				})
				.catch(err => {
					this.$message.error(err.data);
				});
		},
		// 塔机在线状态
		fnOnlineStatusText(_heartbeatTime) {
			return APP.fnOnlineStatusText(_heartbeatTime);
		},
		// 刷新
		fnRefresh() {
			if (this.elevatorData.length > 0) {
				this.fnElevatorToggle(this.elevatorData[this.currentElevatorIndex], this.currentElevatorIndex);
			}
		}
	}
};
</script>
<style lang="scss" scoped>
@import '~@/styles/mixin.scss';
.elevator_box{
	width: 1920px;
	height: 858px;
	position: relative;
	overflow: hidden;
	.elevator{
		position: absolute;
		left: 0;
		right: -20px;
		top: 0;
		bottom: 0;
		overflow-x: hidden;
		overflow-y: auto;
	}
}
.content_list{
	position: absolute;
	top: 0;
	left: 0;
	width: 1600px;
	height: 858px;
	.item_title{
		width: 1580px;
		height: 60px;
		margin: 10px;
		position: relative;
		background: url(../../../assets/img/per_list_bg.png) no-repeat;
		background-size: 100% 100%;
		@include flex-box(flex-start,center);
	}
	.bar{
		font-size: 20px;
		margin: 0 20px;
	}
	.operation{
		position: absolute;
		right: 10px;
		@include flex-box();
		// .add_btn {
		// 	width: 85px;
		// 	height: 32px;
		// 	line-height: 32px;
		// 	margin: 0 2px;
		// 	font-size: 14px;
		// 	color: #ffffff;
		// 	border: none;
		// 	cursor: pointer;
		// 	background: url(../../../assets/img/btn_bg_osm.png) no-repeat;
		// 	background-size: 100% 100%;
		// 	@include flex-box(center, center);
		// 	span {
		// 		margin-top: -2px;
		// 	}
		// }
	}
	.item_box{
		width: 1600px;
		height: 778px;
	}
}
.data_list{
	position: absolute;
	top: 0;
	left: 1620px;
	width: 300px;
	height: 848px;
	margin-top: 10px;
	background-color: rgba(29, 68, 149, 0.1);
	.title {
		width: 300px;
		height: 60px;
		font-size: 24px;
		background: url(../../../assets/img/per_list_bg.png) no-repeat;
		background-size: 100% 100%;
		@include flex-box(center,center);
	}
	.list_title{
		width: 300px;
		height: 48px;
		background: url(../../../assets/img/enter_left_bg.png) no-repeat;
		background-size: 100% 100%;
		@include flex-box(flex-start, center);
		.title_item{
			width: 96px;
			margin: 0 2px;
			text-align: center;
		}
	}
	.list_box{
		width: 300px;
		height: 740px;
		.box_line{
			width: 300px;
			height: 48px;
			cursor: pointer;
			border-bottom: 1px dashed #1d4495;
			@include flex-box(center,center);
			&:hover{
				background-color: rgba(49, 88, 128, 0.4);
			}
			&.active{
				color: #0080FF;
			}
			.line_item{
				width: 96px;
				margin: 0 2px;
				text-align: center;
			}
		}
	}
}

>>> .el-pager .more:before {
	content: '\E794';
}
>>> .el-switch.is-checked .el-switch__core:after {
	content: '';
}
.dialog_mark{
    >>>.el-dialog {
    	width: 720px;
        height: 470px;
        background-color: rgba(9, 17, 32, 1);
        border: 1px solid rgba(58,116,221,1);
    }
    >>>.el-dialog__body{
      padding: 10px;
      height: 360px;
    }
    >>>.el-form-item__label{
    	color: #4DB4F4;
    }
    >>>.el-dialog__title{
    	color: #4DB4F4;
    }
    >>>.el-dialog__close{
    	color: #4DB4F4;
    }
    .btn_line{
        @include flex-box(center,center);
    }
    .mark_content{
      width: 700px;
      height: 340px;
      color: #4DB4F4;
      >>>.el-tabs__item{
          color: #FFFFFF;
      }
      >>>.el-tabs__item.is-active{
          color: #409eff;
      }
      .first_box,.second_box,.third_box{
        width: 700px;
        height: 280px;
        @include flex-box(flex-start,center,column);
        .box_line{
          width: 700px;
          height: 50px;
          line-height: 50px;
          @include flex-box(space-around,center);
          .line_item{
            width: 310px;
            &.btn{
              width: 80px;
            }
            .title{
              display: inline-block;
              width: 100px;
            }
            >>>.el-input{
                width: 170px;
            }
            >>>.el-input__inner{
                width: 170px;
                height: 30px;
                line-height: 30px;
                padding-left: 15px;
                color: rgba(77, 180, 244, 0.7);
                font-size: 12px;
                border: 0;
                outline:none;
                background-color: rgba(49, 88, 128, 0.4);
                &::-webkit-input-placeholder{
                	color: rgba(77, 180, 244, 0.7);
                }
                &::-moz-placeholder{   /* Mozilla Firefox 19+ */
                	color: rgba(77, 180, 244, 0.7);
                }
                &:-moz-placeholder{    /* Mozilla Firefox 4 to 18 */
                	color: rgba(77, 180, 244, 0.7);
                }
                &:-ms-input-placeholder{  /* Internet Explorer 10-11 */
                	color: rgba(77, 180, 244, 0.7);
                }
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/Elevator/elevatorDefault/index.vue